export enum LineType {
  Delivery = 'delivery',
  Item = 'item',
  Service = 'service',
}
